import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './MenuStatusPukal.css';

/* Butang "Status" + menunya. DIKONGSI oleh DUA bar (v3.9, tab Schedule):
     mod 'kad'  = bar pukal kad (senarai kiri) — ada lajur set, sebab satu kad
                  membawa 3 set.
     mod 'slot' = bar pukal slot (kalendar, 2026-09-23) — TIADA lajur set,
                  sebab satu slot MEMANG satu kad + satu set. Meletakkan soalan
                  set di situ = kawalan palsu (satu tarikh boleh bercampur set
                  1/2/3 daripada kad berlainan, dan status dikenakan pada slot
                  yang ditanda sahaja).
   ⛔ Satu komponen, dua mod — jangan salin fail ini untuk bar kedua.

   Nota asal (mod kad):
   Ganti butang "Kosongkan Status" (arahan user 2026-09-18, lakaran diluluskan):
     kiri  = pilih set; nombornya = berapa kad yang akan disentuh untuk AKAUN
             YANG DIBUKA di kalendar (kad ada video untuk set itu, atau sudah
             ada pil). Set kosong kekal dipapar tetapi kelabu (2026-09-20).
     kanan = status baharu: Scheduled · Draft · Failed · Not run yet (= kosongkan)
   Kepala menu menyebut akaun itu, supaya skop tindakan sentiasa kelihatan.
   Status boleh DITANDA sendiri pada banyak kad sekali gus — bukan sekadar
   menukar pil sedia ada (arahan user 2026-09-20).

   RUPA sahaja. Logik tukar status: `bulkTukarStatus` dalam WorkspaceView +
   utils/statusAkaunKad.js. Buka/tutup dipegang WorkspaceView (butang lain
   dalam bar menutup menu ini, sama seperti dropdown bar yang lain).

   ⛔ Panel WAJIB `div` berkelas `bg-white`: peraturan bar dalam index.css
      (`.sesaat-barpukal-v39 div[class*="bg-white"] ...`) memulangkan panel
      kepada permukaan tema. Tanpa kelas itu, teks panel diwarnakan untuk
      permukaan TERBALIK bar — teks putih di atas panel putih.
   ⛔ Menu ini melayang di bawah bar, dalam lajur senarai yang ada tatal
      sendiri — jangan biar ia melimpah ke kanan (ia akan terpotong atau
      mencetuskan tatal mendatar). Ia dianjak ke kiri bila perlu. */

const SET = ['set1', 'set2', 'set3'];
const PILIHAN = [
    { st: 'complete', kunci: 'workspace.tiktok.cal.stDone', lalai: 'Scheduled', warna: 'var(--s-ok)' },
    /* ★ [2026-09-29] 'posted' = complete + md 'now' (utils/statusAkaunKad.js). */
    { st: 'posted', kunci: 'workspace.tiktok.cal.stPosted', lalai: 'Posted', warna: 'var(--s-ok)' },
    { st: 'draft', kunci: 'workspace.tiktok.cal.stDraft', lalai: 'Draft', warna: 'var(--s-warn)' },
    { st: 'failed', kunci: 'workspace.tiktok.cal.stFail', lalai: 'Failed', warna: 'var(--s-stop)' },
    { st: '', kunci: 'workspace.tiktok.cal.stNone', lalai: 'Not run yet', warna: '' },
];

export default function MenuStatusPukal({
    buka, onTogol, onTutup, namaAkaun, onPilih, T,
    kiraan, labelSet,            /* mod 'kad' sahaja */
    mod = 'kad', bilSlot = 0, tajukButang = '',
}) {
    const modSlot = mod === 'slot';
    /* Set yang dipilih di lajur kiri. '' = belum dipilih → set pertama yang
       ada pil. Dikira setiap render (bukan disimpan dari effect), jadi pilihan
       yang sudah tiada pil jatuh sendiri kepada set yang masih ada. */
    const [pilihan, setPilihan] = useState('');
    const bungkusRef = useRef(null);
    const menuRef = useRef(null);
    const setAktif = pilihan === 'all' || (pilihan && kiraan?.[pilihan] > 0)
        ? pilihan
        : (SET.find((k) => kiraan?.[k] > 0) || 'all');

    /* Tutup bila klik di luar atau tekan Esc. */
    useEffect(() => {
        if (!buka) return undefined;
        const luar = (e) => { if (bungkusRef.current && !bungkusRef.current.contains(e.target)) onTutup(); };
        const esc = (e) => { if (e.key === 'Escape') onTutup(); };
        document.addEventListener('mousedown', luar);
        document.addEventListener('keydown', esc);
        return () => {
            document.removeEventListener('mousedown', luar);
            document.removeEventListener('keydown', esc);
        };
    }, [buka, onTutup]);

    /* Kekalkan menu di dalam lebar bar (anjak ke kiri bila melimpah). Ditulis
       terus pada gaya DOM — tiada setState, jadi tiada render tambahan. */
    useLayoutEffect(() => {
        const m = menuRef.current;
        if (!buka || !m) return;
        m.style.left = '0px';
        const bar = bungkusRef.current?.closest('.sesaat-barpukal-v39') || bungkusRef.current?.parentElement;
        if (!bar) return;
        const mr = m.getBoundingClientRect();
        const br = bar.getBoundingClientRect();
        let anjak = 0;
        if (mr.right > br.right) anjak = mr.right - br.right;
        if (mr.left - anjak < br.left) anjak = Math.max(0, mr.left - br.left);
        if (anjak) m.style.left = `${-Math.round(anjak)}px`;
    }, [buka]);

    const jumlah = kiraan?.jumlah || 0;
    const frasaSet = setAktif === 'all' ? T('ws.status.semuaSetFrasa', 'semua set') : labelSet(setAktif);
    /* ⛔ Set yang TIADA apa-apa untuk disentuh (tiada video, tiada pil) kekal
       DIPAPAR tetapi kelabu + tidak boleh ditekan — arahan user 2026-09-20
       ("jangan sorok, tapi lock"). Menyoroknya membuat pengguna tertanya
       "kenapa Set 2 dan Set 3 tiada?" sedangkan sebabnya cuma set itu kosong. */
    const baris = (k, label, bil) => (
        <button
            key={k}
            type="button"
            onClick={() => { if (bil > 0) setPilihan(k); }}
            disabled={bil === 0}
            className={`msp-baris${setAktif === k && bil > 0 ? ' msp-baris--on' : ''}${bil === 0 ? ' msp-baris--mati' : ''}`}
            aria-pressed={setAktif === k && bil > 0}
            title={bil === 0 ? T('ws.status.setKosong', 'Tiada video dan tiada status untuk set ini pada kad yang ditanda') : undefined}
        >
            <span className="msp-baris__label">{label}</span>
            <span className="msp-baris__kira">
                {bil}
                <span className="material-symbols-outlined">chevron_right</span>
            </span>
        </button>
    );

    return (
        <div className="relative" ref={bungkusRef}>
            <button
                type="button"
                onClick={onTogol}
                aria-haspopup="menu"
                aria-expanded={!!buka}
                className="px-2 sm:px-3 py-1.5 text-[10px] sm:text-[11px] font-bold text-teal-600 hover:text-white bg-teal-50 hover:bg-teal-500 rounded-xl flex items-center gap-1 sm:gap-1.5 transition-all"
                title={tajukButang || T('ws.pukal.statusTitle', 'Tukar atau kosongkan status pada kad yang ditanda — untuk akaun yang sedang dibuka di kalendar. Slot kalendar akaun itu ikut sama; video dan caption tidak disentuh.')}
            >
                <span className="material-symbols-outlined text-[14px] sm:text-[15px]">checklist</span>{T('ws.pukal.status', 'Status')}
                <span className="material-symbols-outlined text-[12px]">expand_more</span>
            </button>
            {buka && (
                <div ref={menuRef} role="menu" className="msp-menu absolute left-0 top-full mt-1 bg-white rounded-xl shadow-2xl border border-slate-200 z-50">
                    {!modSlot && (
                        <div className="msp-lajur">
                            <div className="msp-kepala" title={namaAkaun || undefined}>
                                {T('ws.status.akaun', `Akaun: ${namaAkaun}`, { akaun: namaAkaun })}
                            </div>
                            {SET.map((k) => baris(k, labelSet(k), kiraan?.[k] || 0))}
                            <div className="msp-garis" />
                            {baris('all', T('ws.pukal.semuaSet', 'Semua Set'), jumlah)}
                        </div>
                    )}
                    <div className={`msp-lajur${modSlot ? ' msp-lajur--solo' : ' msp-lajur--kanan'}`}>
                        {modSlot && (
                            <div className="msp-kepala" title={namaAkaun || undefined}>
                                {T('ws.status.akaun', `Akaun: ${namaAkaun}`, { akaun: namaAkaun })}
                            </div>
                        )}
                        <div className={`msp-kepala${modSlot ? ' msp-kepala--sub' : ''}`}>
                            {modSlot
                                ? T('ws.status.tukarSlot', `Tukar ${bilSlot} slot ke`, { n: bilSlot })
                                : T('ws.status.tukarKe', `Tukar ${frasaSet} ke`, { set: frasaSet })}
                        </div>
                        {PILIHAN.map((p) => {
                            const label = T(p.kunci, p.lalai);
                            return (
                                <button
                                    key={p.st || 'kosong'}
                                    type="button"
                                    role="menuitem"
                                    onClick={() => onPilih(modSlot ? null : setAktif, p.st, label)}
                                    className="msp-baris msp-baris--status"
                                >
                                    <span
                                        aria-hidden="true"
                                        className={`msp-titik${p.warna ? '' : ' msp-titik--kosong'}`}
                                        style={p.warna ? { background: p.warna } : undefined}
                                    />
                                    {label}
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}
